import { b as __read, c as __assign, d as __rest } from './tslib.es6-71ded574.js';
import React__default, { useState, useEffect, memo, useMemo, useCallback, useRef } from 'react';
import { useIsMobile, useBoolean, useTheme } from '@sravni/react-utils';
import { SPECIAL_INSURANCE_TYPE, SPECIAL_ACTION_TYPES_LIST, SPECIAL_TAB_TO_TITLE_MAP, SPECIAL_OFFERS_LABELS, OFFERS_TABS_DEFAULT_ORDER } from '@sravni/ugc/lib/constants/SpecialOffersAndActions';
import crypto from 'crypto';
import { c as cn } from './index-6c2bf10f.js';
import { Tabs, Menu, Radio, Popover, Typography } from '@sravni/react-design-system';
import { B as BlockListPreloader } from './Preloader-9d4356fa.js';

var calculatePreloaderItemsCount = function (_a) {
    var activeTabType = _a.activeTabType, insidePopup = _a.insidePopup, isMobile = _a.isMobile, isNarrowOnDesktop = _a.isNarrowOnDesktop, isVerticalOnMobile = _a.isVerticalOnMobile, maxDesktopVisibleItems = _a.maxDesktopVisibleItems;
    if (activeTabType === SPECIAL_INSURANCE_TYPE.insuranceOsago)
        return 1;
    if (insidePopup)
        return 4;
    if (isMobile) {
        return isVerticalOnMobile ? 3 : 4;
    }
    if (isNarrowOnDesktop) {
        return 3;
    }
    if (activeTabType && SPECIAL_ACTION_TYPES_LIST.includes(activeTabType)) {
        return 4;
    }
    return maxDesktopVisibleItems || 8;
};

let urlAlphabet =
  'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';

const POOL_SIZE_MULTIPLIER = 128;
let pool, poolOffset;
let fillPool = bytes => {
  if (!pool || pool.length < bytes) {
    pool = Buffer.allocUnsafe(bytes * POOL_SIZE_MULTIPLIER);
    crypto.randomFillSync(pool);
    poolOffset = 0;
  } else if (poolOffset + bytes > pool.length) {
    crypto.randomFillSync(pool);
    poolOffset = 0;
  }
  poolOffset += bytes;
};
let nanoid = (size = 21) => {
  fillPool((size -= 0));
  let id = '';
  for (let i = poolOffset - size; i < poolOffset; i++) {
    id += urlAlphabet[pool[i] & 63];
  }
  return id
};

var useGenerateSpecialUrl = function (_a) {
    var propIframeSrc = _a.propIframeSrc, params = _a.params;
    var _b = __read(useState(''), 2), iframeDomain = _b[0], setIframeDomain = _b[1];
    var _c = __read(useState(''), 2), iframeSrc = _c[0], setIframeSrc = _c[1];
    var _d = __read(useState(nanoid), 1), iframeId = _d[0];
    var defaultUrl = iframeDomain + "/special-offers/";
    useEffect(function () {
        if (propIframeSrc) {
            setIframeDomain(propIframeSrc);
        }
        else {
            setIframeDomain(window.location.protocol +
                '//' +
                window.location.hostname +
                (window.location.port ? ':' + window.location.port : ''));
        }
    }, [propIframeSrc]);
    useEffect(function () {
        if (!iframeDomain)
            return;
        var allParams = __assign(__assign({}, params), { iframeId: iframeId });
        var url = new URL(defaultUrl);
        Object.entries(allParams).forEach(function (_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            if (Array.isArray(value)) {
                value.forEach(function (v) { return url.searchParams.append(key, v); });
            }
            else if (value) {
                url.searchParams.set(key, value.toString());
            }
        });
        setIframeSrc(url.toString());
    }, [defaultUrl, iframeDomain, iframeId, params]);
    return {
        iframeDomain: iframeDomain,
        iframeSrc: iframeSrc,
        iframeId: iframeId
    };
};

var generateHeadingTitle = function (tabType) {
    if (SPECIAL_ACTION_TYPES_LIST.includes(tabType)) {
        return "\u0412\u0430\u0448\u0438 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F";
    }
    return "\u0418\u043D\u0442\u0435\u0440\u0435\u0441\u043D\u044B\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F";
};

var modules_31ab199a = {"tabPane":"_16sljcg"};
/*SRAVNI__src/innerComponents/UltimateSpecialOffers/src/components/Headings/Headings.module.scss__SRAVNI*/;

var HorizontalHeading = memo(function (_a) {
    var element = _a.element, tabs = _a.tabs, onTabChange = _a.onTabChange, activeTabType = _a.activeTabType, horizontalText = _a.horizontalText, _b = _a.showOneHorizontalTabHeading, showOneHorizontalTabHeading = _b === void 0 ? false : _b;
    var isMobile = useIsMobile();
    var headingText = horizontalText ? horizontalText : generateHeadingTitle(activeTabType) + " " + SPECIAL_TAB_TO_TITLE_MAP[activeTabType];
    var heading = React__default.cloneElement(element, { className: cn('h-mb-20', element.props.className) }, headingText);
    if (!showOneHorizontalTabHeading && tabs.length === 1) {
        return heading;
    }
    return (React__default.createElement(React__default.Fragment, null,
        heading,
        React__default.createElement(Tabs, { onChange: onTabChange, className: isMobile ? 'h-mb-20' : 'h-mb-24' }, tabs.map(function (tab) {
            return React__default.createElement(Tabs.TabPane, { key: tab, title: SPECIAL_OFFERS_LABELS[tab], className: modules_31ab199a.tabPane });
        }))));
});

var PopoverHeading = function (_a) {
    var element = _a.element, activeTabType = _a.activeTabType, tabs = _a.tabs, onTabChange = _a.onTabChange;
    var _b = __read(useBoolean(), 2), isPopupVisible = _b[0], setPopupVisibility = _b[1];
    var popupLayoutContent = useMemo(function () {
        return (React__default.createElement(Menu, null, tabs.map(function (tabType, i) {
            var handleMenuItemClick = function () {
                onTabChange(i);
                setPopupVisibility.off();
            };
            return React__default.createElement(Menu.Item, { control: React__default.createElement(Radio, null), key: tabType, active: tabType === activeTabType, onClick: handleMenuItemClick }, SPECIAL_TAB_TO_TITLE_MAP[tabType]);
        })));
    }, [activeTabType, onTabChange, setPopupVisibility, tabs]);
    var children = (tabs.length === 1
        ? generateHeadingTitle(activeTabType) + " " + SPECIAL_TAB_TO_TITLE_MAP[activeTabType]
        : (React__default.createElement(React__default.Fragment, null,
            generateHeadingTitle(activeTabType),
            ' ',
            React__default.createElement(Popover, { visible: isPopupVisible, content: popupLayoutContent, onClose: setPopupVisibility.off, positionerSettings: { matchWidth: false }, backdrop: true },
                React__default.createElement(Typography.Link, { onClick: setPopupVisibility.on }, SPECIAL_TAB_TO_TITLE_MAP[activeTabType])))));
    var propsForCloningElement = (__assign(__assign({}, element.props), { className: cn('h-mb-20', element.props.className) }));
    return React__default.cloneElement(element, propsForCloningElement, children);
};

var Headings$1 = function (_a) {
    var type = _a.type, heading = _a.heading, tabs = _a.tabs, activeTabType = _a.activeTabType, setActiveTabType = _a.setActiveTabType, horizontalText = _a.horizontalText, showOneHorizontalTabHeading = _a.showOneHorizontalTabHeading;
    var _b = __read(useState(), 2), activeTabKey = _b[0], setActiveTabKey = _b[1];
    useEffect(function () {
        if (!activeTabKey && activeTabKey !== 0)
            return;
        setActiveTabType(tabs[activeTabKey]);
    }, [activeTabKey, setActiveTabType, tabs]);
    var handleTabChange = useCallback(function (key) {
        setActiveTabKey(key);
    }, []);
    if (!activeTabType)
        return null;
    var props = ({
        tabs: tabs,
        element: heading,
        activeTabType: activeTabType,
        onTabChange: handleTabChange
    });
    if (type === 'horizontal') {
        return React__default.createElement(HorizontalHeading, __assign({}, props, { horizontalText: horizontalText, showOneHorizontalTabHeading: showOneHorizontalTabHeading }));
    }
    return React__default.createElement(PopoverHeading, __assign({}, props));
};

var modules_3999ddfa = {"iframe":"_1q8ej95"};
import "../assets/SpecialOffers.css";

var sendMessageToSpecialOffersFrontend = function (iframeRef, payload) {
    var _a, _b;
    (_b = (_a = iframeRef === null || iframeRef === void 0 ? void 0 : iframeRef.current) === null || _a === void 0 ? void 0 : _a.contentWindow) === null || _b === void 0 ? void 0 : _b.postMessage({
        source: 'special-offers-iframe-wrapper',
        payload: payload
    }, '*');
};
var Iframe$1 = function (_a) {
    var iframeSrc = _a.iframeSrc, domain = _a.domain, pushEvent = _a.pushEvent, propsIframeId = _a.iframeId, onLoad = _a.onLoad, setItemsCount = _a.setItemsCount, activeTabType = _a.activeTabType, maxDesktopVisibleItems = _a.maxDesktopVisibleItems, handleReceivingAvailableTabs = _a.handleReceivingAvailableTabs, tabs = _a.tabs, _b = _a.isWithLinkToAll, isWithLinkToAll = _b === void 0 ? true : _b;
    var _c = __read(useState(0), 2), iframeHeight = _c[0], setIframeHeight = _c[1];
    var isMobile = useIsMobile();
    var _d = __read(useTheme(), 1), theme = _d[0];
    var _e = __read(useBoolean(false), 2), isLoaded = _e[0], setLoaded = _e[1];
    var iframeRef = useRef(null);
    var handleLoad = function () {
        setLoaded.on();
        onLoad && onLoad();
    };
    useEffect(function () {
        var listener = function (_a) {
            var origin = _a.origin, data = _a.data;
            var source = data.source, payload = data.payload;
            if (origin !== domain || source !== 'special-offers')
                return;
            var height = payload.height, url = payload.url, type = payload.type, event = payload.event, iframeId = payload.iframeId, itemsCount = payload.itemsCount, availableTabs = payload.availableTabs;
            if (iframeId !== propsIframeId)
                return;
            if (type === 'itemsCount') {
                setItemsCount(itemsCount);
                return;
            }
            if (type === 'generalLinkClick') {
                document.location.href = url;
                return;
            }
            if (type === 'changeHeight') {
                setIframeHeight(height);
                return;
            }
            if (type === 'pushEvent') {
                pushEvent(event);
                return;
            }
            if (type === 'listenerIsAdded') {
                handleLoad();
                return;
            }
            if (type === 'availableTabs') {
                handleReceivingAvailableTabs(availableTabs);
                return;
            }
        };
        window.addEventListener('message', listener);
        return function () {
            window.removeEventListener('message', listener);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [domain, handleReceivingAvailableTabs, propsIframeId, pushEvent, setItemsCount, setLoaded]);
    useEffect(function () {
        if (!isLoaded)
            return;
        sendMessageToSpecialOffersFrontend(iframeRef, {
            type: 'changeTheme',
            theme: theme
        });
    }, [isLoaded, theme]);
    useEffect(function () {
        if (!isLoaded)
            return;
        sendMessageToSpecialOffersFrontend(iframeRef, {
            type: 'changeIsMobile',
            isMobile: isMobile
        });
    }, [isLoaded, isMobile]);
    useEffect(function () {
        if (!isLoaded || !activeTabType)
            return;
        sendMessageToSpecialOffersFrontend(iframeRef, {
            type: 'activeTabType',
            activeTabType: activeTabType
        });
    }, [activeTabType, isLoaded]);
    var tabsDeps = JSON.stringify(tabs);
    useEffect(function () {
        if (!isLoaded)
            return;
        sendMessageToSpecialOffersFrontend(iframeRef, {
            type: 'allTabs',
            allTabs: tabs
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoaded, tabsDeps]);
    useEffect(function () {
        if (!isLoaded)
            return;
        sendMessageToSpecialOffersFrontend(iframeRef, {
            type: 'maxDesktopVisibleItems',
            maxDesktopVisibleItems: maxDesktopVisibleItems
        });
    }, [maxDesktopVisibleItems, isLoaded]);
    useEffect(function () {
        if (!isLoaded)
            return;
        sendMessageToSpecialOffersFrontend(iframeRef, {
            type: 'pageUrl',
            pageUrl: document.location.href
        });
    }, [isLoaded]);
    useEffect(function () {
        if (!isLoaded)
            return;
        sendMessageToSpecialOffersFrontend(iframeRef, {
            type: 'isWithLinkToAll',
            isWithLinkToAll: isWithLinkToAll
        });
    }, [isLoaded, isWithLinkToAll]);
    return (React__default.createElement("iframe", { height: iframeHeight + "px", className: cn(modules_3999ddfa.iframe), src: iframeSrc, title: 'Интересные предложения', ref: iframeRef }));
};

var UltimateSpecialOffers$1 = function (_a) {
    var _b = _a.headingType, headingType = _b === void 0 ? 'popover' : _b, heading = _a.heading, horizontalTitle = _a.horizontalTitle, propIframeSrc = _a.iframeSrc, isBVersion = _a.isBVersion, onTabChange = _a.onTabChange, abName = _a.abName, _c = _a.tabs, tabs = _c === void 0 ? OFFERS_TABS_DEFAULT_ORDER : _c, isWithButtons = _a.isWithButtons, _d = _a.insidePopup, insidePopup = _d === void 0 ? false : _d, _e = _a.isNarrowOnDesktop, isNarrowOnDesktop = _e === void 0 ? false : _e, onLoad = _a.onLoad, parentSetItemsCount = _a.setItemsCount, bonusFilter = _a.bonusFilter, _f = _a.maxDesktopVisibleItems, maxDesktopVisibleItems = _f === void 0 ? 8 : _f, className = _a.className, activeTabFromProps = _a.activeTab, organizationId = _a.organizationId, onReceivingAvailableTabs = _a.onReceivingAvailableTabs, showOneHorizontalTabHeading = _a.showOneHorizontalTabHeading, _g = _a.isVerticalOnMobile, isVerticalOnMobile = _g === void 0 ? false : _g, props = __rest(_a, ["headingType", "heading", "horizontalTitle", "iframeSrc", "isBVersion", "onTabChange", "abName", "tabs", "isWithButtons", "insidePopup", "isNarrowOnDesktop", "onLoad", "setItemsCount", "bonusFilter", "maxDesktopVisibleItems", "className", "activeTab", "organizationId", "onReceivingAvailableTabs", "showOneHorizontalTabHeading", "isVerticalOnMobile"]);
    // const isFirstRenderRef = useRef<boolean>(true);
    var _h = __read(useBoolean(true), 2), isIframeLoading = _h[0], setIframeLoading = _h[1];
    var isMobile = useIsMobile();
    var _j = __read(useState(null), 2), itemsCount = _j[0], setItemsCount = _j[1];
    var _k = __read(useState(), 2), activeTabType = _k[0], setActiveTabType = _k[1];
    var firstTab = useMemo(function () {
        return activeTabFromProps !== null && activeTabFromProps !== void 0 ? activeTabFromProps : tabs === null || tabs === void 0 ? void 0 : tabs[0];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var _l = useGenerateSpecialUrl({
        propIframeSrc: propIframeSrc,
        params: {
            isBVersion: isBVersion,
            abName: abName,
            isWithButtons: isWithButtons,
            isPopup: insidePopup,
            bonusFilter: bonusFilter,
            organizationId: organizationId,
            isVerticalOnMobile: isVerticalOnMobile,
            firstTab: firstTab
        }
    }), iframeDomain = _l.iframeDomain, iframeSrc = _l.iframeSrc, iframeId = _l.iframeId;
    var depsString = JSON.stringify(tabs);
    useEffect(function () {
        setActiveTabType(activeTabFromProps !== null && activeTabFromProps !== void 0 ? activeTabFromProps : tabs[0]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTabFromProps, depsString]);
    useEffect(function () {
        if (!activeTabType)
            return;
        onTabChange && onTabChange(activeTabType);
    }, [activeTabType, onTabChange]);
    var handleLoad = function () {
        setIframeLoading.off();
        onLoad && onLoad();
    };
    var preloaderItemsCount = calculatePreloaderItemsCount({
        activeTabType: activeTabType,
        insidePopup: insidePopup,
        isMobile: isMobile,
        isNarrowOnDesktop: isNarrowOnDesktop,
        isVerticalOnMobile: isVerticalOnMobile,
        maxDesktopVisibleItems: maxDesktopVisibleItems
    });
    var handleItemsCount = function (count) {
        setItemsCount(count);
        parentSetItemsCount && parentSetItemsCount(count);
    };
    var handleReceivingAvailableTabs = function (tabs) {
        onReceivingAvailableTabs && onReceivingAvailableTabs(tabs);
    };
    if (!iframeSrc)
        return null;
    return (React__default.createElement("div", { className: className },
        !!heading && React__default.createElement(Headings$1, { type: headingType, heading: heading, tabs: tabs, activeTabType: activeTabType, setActiveTabType: setActiveTabType, horizontalText: horizontalTitle, showOneHorizontalTabHeading: showOneHorizontalTabHeading }),
        (isIframeLoading || itemsCount === null)
            && React__default.createElement(BlockListPreloader, { itemsCount: preloaderItemsCount, isPopup: insidePopup, isVerticalOnMobile: isVerticalOnMobile }),
        React__default.createElement("div", { style: { height: isIframeLoading || itemsCount === null ? '0px' : 'auto', overflow: 'hidden' } },
            React__default.createElement(Iframe$1, __assign({ iframeSrc: iframeSrc, domain: iframeDomain, iframeId: iframeId, onLoad: handleLoad, activeTabType: activeTabType, setItemsCount: handleItemsCount, maxDesktopVisibleItems: maxDesktopVisibleItems, handleReceivingAvailableTabs: handleReceivingAvailableTabs, tabs: tabs }, props)))));
};

export { UltimateSpecialOffers$1 as U };
